import { isRejectedWithValue } from "@reduxjs/toolkit";
import autoSignOut from "util/autoSignOut";

const rtkQueryErrorHandler = (api) => (next) => (action) => {
  // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these use matchers!
  if (isRejectedWithValue(action)) {
    // console.warn("We got a rejected action!", action);
    const { status, data } = action.payload;
    autoSignOut(status, data?.error, true);
  }

  return next(action);
};

export default rtkQueryErrorHandler;
